const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i

export function isDesktopCustomerServiceContext() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  if (MOBILE_USER_AGENT.test(String(navigator.userAgent || ''))) return false
  const params = new URLSearchParams(window.location.search || '')
  return params.get('__desktop_frame') === '1' || window.innerWidth > 768
}

export function openCustomerServiceUrl(value) {
  if (typeof window === 'undefined') return false
  const url = String(value || '').trim()
  if (!/^https?:\/\//i.test(url)) return false

  if (isDesktopCustomerServiceContext()) {
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true
  }

  window.location.assign(url)
  return true
}
